import { render, staticRenderFns } from "./SplitActionDropdown.vue?vue&type=template&id=046bfdbb"
import script from "./SplitActionDropdown.vue?vue&type=script&lang=js"
export * from "./SplitActionDropdown.vue?vue&type=script&lang=js"
import style0 from "./SplitActionDropdown.vue?vue&type=style&index=0&id=046bfdbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports